export default "__VITE_ASSET__bJCwIi6M__"